import { render, staticRenderFns } from "./CardReader.vue?vue&type=template&id=c578082c&scoped=true&"
import script from "./CardReader.vue?vue&type=script&lang=js&"
export * from "./CardReader.vue?vue&type=script&lang=js&"
import style0 from "./CardReader.vue?vue&type=style&index=0&id=c578082c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c578082c",
  null
  
)

export default component.exports